import get from 'lodash/get'
import { StyleRoot } from 'radium'
import UAParser from 'ua-parser-js'
import React, { Component } from 'react'
import { Router } from 'react-router-dom'

import Routes from './Routes'
import history from './config/history'
import { getIntercomID } from './config'
import { ALLOW_CROSS_BROWSER, isAmwellTheme } from './lib'
import SukiProvider from './core/SukiContext'

// This is so that all Ant Design Components are dark if in Amwell mode
// To ensure that the conditional import works in a prod environment
// This includes the datePicker in src/containers/note/index.js
// please see https://prawira.medium.com/react-conditional-import-conditional-css-import-110cc58e0da6
import AntdThemeSelector from './core/antdTheme/AntdThemeSelector'

import './App.css'
const SUPPORTED_BROWSERS = ['Chrome', 'Edge', ...(isAmwellTheme() ? ['Firefox'] : []), 'Safari']

const REDIRECT_URL = 'https://www.suki.ai/requirements'

class App extends Component {
  componentWillMount = async () => {
    // Initialize intercom
    window.Intercom('boot', {
      app_id: getIntercomID(),
      hide_default_launcher: true
    })

    const parser = new UAParser()
    const result = parser.getResult()

    const browserName = get(result, 'browser.name')

    const disableRequirements = ALLOW_CROSS_BROWSER.includes(window.location.pathname)

    if (!disableRequirements && !SUPPORTED_BROWSERS.includes(browserName)) {
      window.location.href = REDIRECT_URL
    }
  }

  render () {
    return (
      <StyleRoot>
        <Router history={history}>
          <SukiProvider>
            <AntdThemeSelector>
              <Routes />
            </AntdThemeSelector>
          </SukiProvider>
        </Router>
      </StyleRoot>
    )
  }
}

export default App
